import { render, staticRenderFns } from "./SalesReturnSummary.vue?vue&type=template&id=073bc0fe&"
import script from "./SalesReturnSummary.vue?vue&type=script&lang=js&"
export * from "./SalesReturnSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports